// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =========================================================
   Applications Skeleton — pixel-match to data-grid styles
   Group header:   #0066B2 bg, 32px
   Column header:  #0066B2 bg, 56px
   Filter row:     #f8f9fa bg, 48px, input-like cells
   Data row:       48px, 12px 16px padding
   ========================================================= */

:host {
  display: block;
  width: 100%;
  min-width: 0;
}

.skl-applications {
  width: 100%;
  padding: 0;
}

/* Filter dropdowns row */
.skl-filter-group {
  display: flex;
  flex-direction: column;
}

/* Title block — min-height matches the real h1 (2.5rem × 1.2 line-height × 2 lines = ~86px) */
.skl-title-block {
  min-height: 86px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

/* Grid wrapper */
.skl-grid {
  width: 100%;
  overflow-x: auto;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  background: #fff;
}

/* ── Shared row base ── */
.skl-group-header-row,
.skl-header-row,
.skl-filter-row,
.skl-data-row,
.skl-pagination-bar {
  display: flex;
  align-items: center;
  min-width: max-content;
}

/* ────────────────────────────────────────────────────────
   GROUP HEADER ROW  (#0066B2, 32px, white shimmer)
   ──────────────────────────────────────────────────────── */
.skl-group-header-row {
  background: #0066B2;
  height: 32px;
  min-height: 32px;
}

/* White shimmer on blue background */
.skl-group-header-row ::ng-deep .skeleton-block,
.skl-header-row ::ng-deep .skeleton-block {
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0.20) 25%,
    rgba(255, 255, 255, 0.38) 50%,
    rgba(255, 255, 255, 0.20) 75%
  ) !important;
  background-size: 200% 100% !important;
  animation: shimmer 1.5s ease-in-out infinite !important;
}

.skl-col-group {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 12px;
  border-left: 1px solid rgba(255, 255, 255, 0.25);
  height: 100%;
}

.skl-col-group-cmdb {
  flex: 4 0 calc(150px + 150px + 150px + 190px); /* readiness + analysis + keyreason + recommendation */
}

.skl-col-group-code {
  flex: 2 0 calc(150px + 160px); /* complexity + codekeyreason */
  border-right: 1px solid rgba(255, 255, 255, 0.25);
}

/* ────────────────────────────────────────────────────────
   COLUMN HEADER ROW  (#0066B2, 56px, white shimmer)
   ──────────────────────────────────────────────────────── */
.skl-header-row {
  background: #0066B2;
  height: 56px;
  min-height: 56px;
}

/* ────────────────────────────────────────────────────────
   FILTER ROW  (#f8f9fa, 48px, input-like cells)
   ──────────────────────────────────────────────────────── */
.skl-filter-row {
  background: #f8f9fa;
  height: 48px;
  min-height: 48px;
  border-bottom: 1px solid #dee2e6;
}

.skl-filter-cell {
  display: flex;
  align-items: center;
  padding: 0 12px;
}

/* Mimic filter input box */
.skl-filter-input {
  width: 100%;
  height: 26px;
  background: #fff;
  border: 1px solid #ced4da;
  border-radius: 4px;
  overflow: hidden;
  position: relative;
}

.skl-filter-input::after {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(
    90deg,
    transparent 25%,
    rgba(0, 0, 0, 0.04) 50%,
    transparent 75%
  );
  background-size: 200% 100%;
  animation: shimmer 1.5s ease-in-out infinite;
}

@keyframes shimmer {
  0%   { background-position: -200% 0; }
  100% { background-position:  200% 0; }
}

/* ────────────────────────────────────────────────────────
   DATA ROWS  (56.67px, 12px 16px padding)
   ──────────────────────────────────────────────────────── */
.skl-data-row {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  height: 56.67px;
  min-height: 56.67px;
}

.skl-data-row:last-of-type {
  border-bottom: none;
}

/* ────────────────────────────────────────────────────────
   COLUMN DEFINITIONS  (match displayedColumns widths)
   ──────────────────────────────────────────────────────── */
.skl-col {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 16px;
  overflow: hidden;
  height: 100%;
}

/* Sticky columns */
.skl-col-appid   { flex: 1 0 100px; position: sticky; left: 0;     z-index: 2; }
.skl-col-name    { flex: 1 0 260px; position: sticky; left: 100px; z-index: 2; }
.skl-col-action  { flex: 1 0 200px; position: sticky; right: 0;    z-index: 2; }

/* Sticky separators */
.skl-col-appid  { border-right: 1px solid rgba(255,255,255,0.2); }
.skl-col-name   { border-right: 1px solid rgba(255,255,255,0.2); }
.skl-col-action { border-left:  1px solid rgba(255,255,255,0.2); }

/* Non-sticky columns */
.skl-col-crit           { flex: 1 0 100px; }
.skl-col-users          { flex: 1 0 100px; }
.skl-col-tco            { flex: 1 0 120px; }
.skl-col-incidents      { flex: 1 0 110px; }
.skl-col-platform       { flex: 1 0 150px; }
.skl-col-readiness      { flex: 1 0 150px; }
.skl-col-analysis       { flex: 1 0 150px; border-left: 1px solid rgba(255,255,255,0.2); }
.skl-col-keyreason      { flex: 1 0 150px; }
.skl-col-recommendation { flex: 1 0 190px; }
.skl-col-complexity     { flex: 1 0 150px; border-left: 1px solid rgba(255,255,255,0.2); }
.skl-col-codekeyreason  { flex: 1 0 160px; border-right: 1px solid rgba(255,255,255,0.2); }
.skl-col-assignedrole   { flex: 1 0 150px; }
.skl-col-assignmentdate { flex: 1 0 120px; }

/* In group/header rows sticky cols keep blue bg */
.skl-group-header-row .skl-col-appid,
.skl-group-header-row .skl-col-name,
.skl-group-header-row .skl-col-action,
.skl-header-row .skl-col-appid,
.skl-header-row .skl-col-name,
.skl-header-row .skl-col-action {
  background: #0066B2;
}

/* In filter row sticky cols keep filter-row bg */
.skl-filter-row .skl-col-appid,
.skl-filter-row .skl-col-name,
.skl-filter-row .skl-col-action {
  background: #f8f9fa;
}

/* In data rows sticky cols keep white */
.skl-data-row .skl-col-appid,
.skl-data-row .skl-col-name,
.skl-data-row .skl-col-action {
  background: #fff;
}

/* Group/header col separators for data rows (dark) */
.skl-data-row .skl-col-appid  { border-right: 1px solid #e9ecef; }
.skl-data-row .skl-col-name   { border-right: 1px solid #e9ecef; }
.skl-data-row .skl-col-action { border-left:  1px solid #e9ecef; }
.skl-data-row .skl-col-analysis    { border-left:  1px solid #dee2e6; }
.skl-data-row .skl-col-complexity  { border-left:  1px solid #dee2e6; }
.skl-data-row .skl-col-codekeyreason { border-right: 1px solid #dee2e6; }

/* ── Pagination bar ── */
.skl-pagination-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px;
  border-top: 1px solid #dee2e6;
  background: #fff;
  min-width: 100%;
  position: sticky;
  left: 0;
}

.skl-pagination-buttons {
  display: flex;
  gap: 4px;
}
`, "",{"version":3,"sources":["webpack://./projects/ai_modernization/src/app/applications/applications-skeleton/applications-skeleton.component.css"],"names":[],"mappings":"AAAA;;;;;;8DAM8D;;AAE9D;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA,8FAA8F;AAC9F;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;;;;;EAKE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;;6DAE6D;AAC7D;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA,qCAAqC;AACrC;;EAEE;;;;;cAKY;EACZ,qCAAqC;EACrC,uDAAuD;AACzD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gDAAgD;EAChD,YAAY;AACd;;AAEA;EACE,6CAA6C,EAAE,sDAAsD;AACvG;;AAEA;EACE,6BAA6B,EAAE,+BAA+B;EAC9D,iDAAiD;AACnD;;AAEA;;6DAE6D;AAC7D;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;6DAE6D;AAC7D;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR;;;;;GAKC;EACD,0BAA0B;EAC1B,4CAA4C;AAC9C;;AAEA;EACE,OAAO,4BAA4B,EAAE;EACrC,OAAO,4BAA4B,EAAE;AACvC;;AAEA;;6DAE6D;AAC7D;EACE,4CAA4C;EAC5C,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;6DAE6D;AAC7D;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA,mBAAmB;AACnB,mBAAmB,eAAe,EAAE,gBAAgB,EAAE,OAAO,MAAM,UAAU,EAAE;AAC/E,mBAAmB,eAAe,EAAE,gBAAgB,EAAE,WAAW,EAAE,UAAU,EAAE;AAC/E,mBAAmB,eAAe,EAAE,gBAAgB,EAAE,QAAQ,KAAK,UAAU,EAAE;;AAE/E,sBAAsB;AACtB,kBAAkB,6CAA6C,EAAE;AACjE,kBAAkB,6CAA6C,EAAE;AACjE,kBAAkB,6CAA6C,EAAE;;AAEjE,uBAAuB;AACvB,0BAA0B,eAAe,EAAE;AAC3C,0BAA0B,eAAe,EAAE;AAC3C,0BAA0B,eAAe,EAAE;AAC3C,0BAA0B,eAAe,EAAE;AAC3C,0BAA0B,eAAe,EAAE;AAC3C,0BAA0B,eAAe,EAAE;AAC3C,0BAA0B,eAAe,EAAE,4CAA4C,EAAE;AACzF,0BAA0B,eAAe,EAAE;AAC3C,0BAA0B,eAAe,EAAE;AAC3C,0BAA0B,eAAe,EAAE,4CAA4C,EAAE;AACzF,0BAA0B,eAAe,EAAE,6CAA6C,EAAE;AAC1F,0BAA0B,eAAe,EAAE;AAC3C,0BAA0B,eAAe,EAAE;;AAE3C,kDAAkD;AAClD;;;;;;EAME,mBAAmB;AACrB;;AAEA,iDAAiD;AACjD;;;EAGE,mBAAmB;AACrB;;AAEA,wCAAwC;AACxC;;;EAGE,gBAAgB;AAClB;;AAEA,qDAAqD;AACrD,gCAAgC,+BAA+B,EAAE;AACjE,gCAAgC,+BAA+B,EAAE;AACjE,gCAAgC,+BAA+B,EAAE;AACjE,qCAAqC,+BAA+B,EAAE;AACtE,qCAAqC,+BAA+B,EAAE;AACtE,uCAAuC,+BAA+B,EAAE;;AAExE,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,OAAO;AACT;;AAEA;EACE,aAAa;EACb,QAAQ;AACV","sourcesContent":["/* =========================================================\n   Applications Skeleton — pixel-match to data-grid styles\n   Group header:   #0066B2 bg, 32px\n   Column header:  #0066B2 bg, 56px\n   Filter row:     #f8f9fa bg, 48px, input-like cells\n   Data row:       48px, 12px 16px padding\n   ========================================================= */\n\n:host {\n  display: block;\n  width: 100%;\n  min-width: 0;\n}\n\n.skl-applications {\n  width: 100%;\n  padding: 0;\n}\n\n/* Filter dropdowns row */\n.skl-filter-group {\n  display: flex;\n  flex-direction: column;\n}\n\n/* Title block — min-height matches the real h1 (2.5rem × 1.2 line-height × 2 lines = ~86px) */\n.skl-title-block {\n  min-height: 86px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n/* Grid wrapper */\n.skl-grid {\n  width: 100%;\n  overflow-x: auto;\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  background: #fff;\n}\n\n/* ── Shared row base ── */\n.skl-group-header-row,\n.skl-header-row,\n.skl-filter-row,\n.skl-data-row,\n.skl-pagination-bar {\n  display: flex;\n  align-items: center;\n  min-width: max-content;\n}\n\n/* ────────────────────────────────────────────────────────\n   GROUP HEADER ROW  (#0066B2, 32px, white shimmer)\n   ──────────────────────────────────────────────────────── */\n.skl-group-header-row {\n  background: #0066B2;\n  height: 32px;\n  min-height: 32px;\n}\n\n/* White shimmer on blue background */\n.skl-group-header-row ::ng-deep .skeleton-block,\n.skl-header-row ::ng-deep .skeleton-block {\n  background: linear-gradient(\n    90deg,\n    rgba(255, 255, 255, 0.20) 25%,\n    rgba(255, 255, 255, 0.38) 50%,\n    rgba(255, 255, 255, 0.20) 75%\n  ) !important;\n  background-size: 200% 100% !important;\n  animation: shimmer 1.5s ease-in-out infinite !important;\n}\n\n.skl-col-group {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 12px;\n  border-left: 1px solid rgba(255, 255, 255, 0.25);\n  height: 100%;\n}\n\n.skl-col-group-cmdb {\n  flex: 4 0 calc(150px + 150px + 150px + 190px); /* readiness + analysis + keyreason + recommendation */\n}\n\n.skl-col-group-code {\n  flex: 2 0 calc(150px + 160px); /* complexity + codekeyreason */\n  border-right: 1px solid rgba(255, 255, 255, 0.25);\n}\n\n/* ────────────────────────────────────────────────────────\n   COLUMN HEADER ROW  (#0066B2, 56px, white shimmer)\n   ──────────────────────────────────────────────────────── */\n.skl-header-row {\n  background: #0066B2;\n  height: 56px;\n  min-height: 56px;\n}\n\n/* ────────────────────────────────────────────────────────\n   FILTER ROW  (#f8f9fa, 48px, input-like cells)\n   ──────────────────────────────────────────────────────── */\n.skl-filter-row {\n  background: #f8f9fa;\n  height: 48px;\n  min-height: 48px;\n  border-bottom: 1px solid #dee2e6;\n}\n\n.skl-filter-cell {\n  display: flex;\n  align-items: center;\n  padding: 0 12px;\n}\n\n/* Mimic filter input box */\n.skl-filter-input {\n  width: 100%;\n  height: 26px;\n  background: #fff;\n  border: 1px solid #ced4da;\n  border-radius: 4px;\n  overflow: hidden;\n  position: relative;\n}\n\n.skl-filter-input::after {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(\n    90deg,\n    transparent 25%,\n    rgba(0, 0, 0, 0.04) 50%,\n    transparent 75%\n  );\n  background-size: 200% 100%;\n  animation: shimmer 1.5s ease-in-out infinite;\n}\n\n@keyframes shimmer {\n  0%   { background-position: -200% 0; }\n  100% { background-position:  200% 0; }\n}\n\n/* ────────────────────────────────────────────────────────\n   DATA ROWS  (56.67px, 12px 16px padding)\n   ──────────────────────────────────────────────────────── */\n.skl-data-row {\n  border-bottom: 1px solid rgba(0, 0, 0, 0.12);\n  height: 56.67px;\n  min-height: 56.67px;\n}\n\n.skl-data-row:last-of-type {\n  border-bottom: none;\n}\n\n/* ────────────────────────────────────────────────────────\n   COLUMN DEFINITIONS  (match displayedColumns widths)\n   ──────────────────────────────────────────────────────── */\n.skl-col {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: 0 16px;\n  overflow: hidden;\n  height: 100%;\n}\n\n/* Sticky columns */\n.skl-col-appid   { flex: 1 0 100px; position: sticky; left: 0;     z-index: 2; }\n.skl-col-name    { flex: 1 0 260px; position: sticky; left: 100px; z-index: 2; }\n.skl-col-action  { flex: 1 0 200px; position: sticky; right: 0;    z-index: 2; }\n\n/* Sticky separators */\n.skl-col-appid  { border-right: 1px solid rgba(255,255,255,0.2); }\n.skl-col-name   { border-right: 1px solid rgba(255,255,255,0.2); }\n.skl-col-action { border-left:  1px solid rgba(255,255,255,0.2); }\n\n/* Non-sticky columns */\n.skl-col-crit           { flex: 1 0 100px; }\n.skl-col-users          { flex: 1 0 100px; }\n.skl-col-tco            { flex: 1 0 120px; }\n.skl-col-incidents      { flex: 1 0 110px; }\n.skl-col-platform       { flex: 1 0 150px; }\n.skl-col-readiness      { flex: 1 0 150px; }\n.skl-col-analysis       { flex: 1 0 150px; border-left: 1px solid rgba(255,255,255,0.2); }\n.skl-col-keyreason      { flex: 1 0 150px; }\n.skl-col-recommendation { flex: 1 0 190px; }\n.skl-col-complexity     { flex: 1 0 150px; border-left: 1px solid rgba(255,255,255,0.2); }\n.skl-col-codekeyreason  { flex: 1 0 160px; border-right: 1px solid rgba(255,255,255,0.2); }\n.skl-col-assignedrole   { flex: 1 0 150px; }\n.skl-col-assignmentdate { flex: 1 0 120px; }\n\n/* In group/header rows sticky cols keep blue bg */\n.skl-group-header-row .skl-col-appid,\n.skl-group-header-row .skl-col-name,\n.skl-group-header-row .skl-col-action,\n.skl-header-row .skl-col-appid,\n.skl-header-row .skl-col-name,\n.skl-header-row .skl-col-action {\n  background: #0066B2;\n}\n\n/* In filter row sticky cols keep filter-row bg */\n.skl-filter-row .skl-col-appid,\n.skl-filter-row .skl-col-name,\n.skl-filter-row .skl-col-action {\n  background: #f8f9fa;\n}\n\n/* In data rows sticky cols keep white */\n.skl-data-row .skl-col-appid,\n.skl-data-row .skl-col-name,\n.skl-data-row .skl-col-action {\n  background: #fff;\n}\n\n/* Group/header col separators for data rows (dark) */\n.skl-data-row .skl-col-appid  { border-right: 1px solid #e9ecef; }\n.skl-data-row .skl-col-name   { border-right: 1px solid #e9ecef; }\n.skl-data-row .skl-col-action { border-left:  1px solid #e9ecef; }\n.skl-data-row .skl-col-analysis    { border-left:  1px solid #dee2e6; }\n.skl-data-row .skl-col-complexity  { border-left:  1px solid #dee2e6; }\n.skl-data-row .skl-col-codekeyreason { border-right: 1px solid #dee2e6; }\n\n/* ── Pagination bar ── */\n.skl-pagination-bar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 16px;\n  border-top: 1px solid #dee2e6;\n  background: #fff;\n  min-width: 100%;\n  position: sticky;\n  left: 0;\n}\n\n.skl-pagination-buttons {\n  display: flex;\n  gap: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
